'use es6';

import { getLinkPluginSetting, getPluginSetting } from '../utils';
import { isRawUrl } from '../utils/url';
import { isNodeWithinLink, convertRootRelLinkToAbsUrl, convertPageRelLinkToAbsUrl, insertOrEditLink, adaptLinkPropsToAttr } from '../utils/link';
import { hslinkConfig, savedLinkFields, LINK_SETTINGS } from '../constants/hslink';
function getSavedHref(savedLinkInfo) {
  return savedLinkInfo[savedLinkFields.HREF];
}
export function getAbsoluteMailtoOrHashLink(editor, href) {
  if (isRawUrl(href)) {
    return href;
  } else if (href[0] === '/') {
    return convertRootRelLinkToAbsUrl(editor, href);
  }
  return convertPageRelLinkToAbsUrl(editor, href);
}
export function getPopoverLinkSettings(editor) {
  return getPluginSetting(editor, LINK_SETTINGS);
}
export function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
export function truncateSameDomainLink(contentDomain, href) {
  if (!href || !contentDomain) {
    return href;
  }
  const regex = new RegExp(`^https?://${escapeRegExp(contentDomain)}`);
  const hrefDomain = href.replace(/(^\w+:|^)\/\//, '').split('/')[0];
  if (hrefDomain === contentDomain) {
    return href.replace(regex, '') || '/';
  }
  return href;
}
export function handleLinkInfoSave(editor, target, linkInfo, action) {
  if (!linkInfo[savedLinkFields.HREF]) {
    editor.execCommand('unlink');
    return;
  }
  if (!linkInfo[savedLinkFields.TEXT] && editor.selection.isCollapsed() && !isNodeWithinLink(editor, target)) {
    linkInfo[savedLinkFields.TEXT] = linkInfo[savedLinkFields.HREF];
  }
  const allowRelativeLinks = getLinkPluginSetting(editor, hslinkConfig.ALLOW_RELATIVE_LINKS);
  if (allowRelativeLinks) {
    linkInfo[savedLinkFields.HREF] = truncateSameDomainLink(editor.settings.contentDomain, getSavedHref(linkInfo));
  }
  insertOrEditLink(editor, target, linkInfo, action);
}
export const onLinkUpdate = (editor, target, linkOptions, action) => {
  const linkInfo = adaptLinkPropsToAttr(linkOptions);
  handleLinkInfoSave(editor, target, linkInfo, action);
};
export const getAnchorPreviewClickHandler = editor => href => {
  if (!href.startsWith('#')) return;
  const anchor = editor.$(href)[0];
  if (anchor) {
    anchor.scrollIntoView({
      behavior: 'smooth'
    });
  }
};

/**
 * Prevent default whenever a link is clicked in the editor. This came about from
 * this JIRA: https://issues.hubspotcentral.com/browse/CG-15348 where clicking
 * links in the editor were redirecting to their respective urls in the Inpage Editors.
 * A combination of Content Editor inpage context & GTM (Google Tag Manager) are
 * at play here, causing the default nature of "noneditable" to be insufficient.
 */
export const getPreventDefaultOnLinkClick = editor => evt => {
  const linkNode = isNodeWithinLink(editor, evt.target);
  if (linkNode) {
    evt.preventDefault();
  }
};